// extracted by mini-css-extract-plugin
export default {"list":"tabs_list__Qxoro","indicator":"tabs_indicator__jX35Z","tab":"tabs_tab__CNga1"};